import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import IUtils from './IUtils';
import UIUtils from '../util/UIUtils';
import Special from '../components/Special';
// import SSRecaptcha from '../base/SSRecaptcha';

class DelHeader extends React.Component {
  render() {
    return (
      <div>
        <Special />
        {this.getBreadCrumb()}
        <h4 style={{align: "center"}}><span><strong>{IUtils.nameFormatterNoLink(this.props.delegate.name)} - {this.props.title}</strong></span>
          {UIUtils.renderPageActions(this, false, true)}
        </h4>
        <p>{this.getLastUpdatedGap(this.props.delegate.lastUpdatedGap)}
          <span className="buttonWithText">{IUtils.voteFormatterLarge(this.props.delegate.registeredName, this.props.delegate)}</span></p>
        {UIUtils.getNotification(this.props.notification)}
      </div>
    );
  }
  // <SSRecaptcha />

  getLastUpdatedGap(value) {
    let lastUpdated = value ? (value/60).toFixed(0) : "N/A";
    return (<span>Last updated - <b>{lastUpdated}</b> minutes ago.</span>);
  }


  getBreadCrumb() {
    if (window.innerWidth < 1000) {
      return (
        <Breadcrumb>
          <Breadcrumb.Item href="/">Validators</Breadcrumb.Item>
        </Breadcrumb>
      );
    } else {
      return "";
    }
  }

// <!--  <Breadcrumb.Item active>{this.props.pool.poolName} - Pool</Breadcrumb.Item> -->
  reload() {
    // window.location = "/val/" + this.state.val.poolId;
    window.location.reload();
  }

}

export default DelHeader;



// WEBPACK FOOTER //
// ./src/iotex/DelHeader.js